<template>
  <div id="DialogComparison">
    <md-dialog :md-active.sync="showDialog" :md-backdrop="false" class="comparison-list">
      <button class="closeDialogComparison" @click="clearComparionList">x</button>
      <div class="comparison-images">
        <template v-for="index in comparisonList">
          <div :key="index" style="position: relative;  float: left;  margin: 0px 10px;">
            <button @click="removeItem(index)" style="position: absolute;  right: -5px;  top: -5px;  background: none;  border: none;  color: red;  cursor: pointer;">x</button>
            <img v-if="index" v-lazy="$url_img(index)" class="pic" style="width: 30px; max-height: 35px;"/>
          </div>
        </template>
      </div>
      <button v-if="Object.keys(comparisonList).length>1" class="md-manual" @click="comparisonProducts()" style="">{{ $t("porownaj") }}</button>
      <!-- <md-button v-if="Object.keys(comparisonList).length>1" class="md-manual" @click="comparisonProducts" style="">porównaj</md-button> -->
    </md-dialog>

  </div>
</template>

<script>

import { helpers } from "../../mixins/helpers"
import { auth } from '../../mixins/auth'
import { mapGetters } from "vuex"

export default {
  name: "DialogComparisons",
  mixins: [auth, helpers],
  props: ['showDialog'],
  data() {
    return {};
  },
  computed: {
    ...mapGetters('products', ["comparisonList","parametrsProducts"]),
  },
  methods: {
    $url_img(elem) {
      //let prod = (elem.indexOf('/'))?elem.replace('/',','):elem;
      let prod = this.slash_to_comma(elem)
      return process.env.VUE_APP_ROOT_IMG + prod + "_1.png"
    },
    clearComparionList () {
      this.$store.commit('products/SET_COMPARISONS', null)
    },
    removeItem (code) {
      // this.$store.commit('products/SET_COMPARISONS', code)
          this.$store.commit('products/REMOVE_COMPARISON', code)
    },
    comparisonProducts () {
      console.log(this.comparisonList)
      this.$store.dispatch('products/get_data_values',this.comparisonList)
      this.$emit('clickDialogComparison', true)
    }
  }
}

</script>

<style scoped>
.comparison-list {
  width: 310px;
  top: 92% !important;
  left: 20px !important;
  z-index: 10;
}
.comparison-clear {
  height: 68px;
}
.comparison-clear button {
  margin: 0px !important;
  height: 28px !important;
  position: absolute;
  top: 15px;
}
.comparison-images {
  margin: 15px 8px 14px;
  height: 45px;
}
.comparison-list .md-dialog-container {
  height: 70px;
}
.comparison-clear button {
  margin: 0px !important;
  width: 30px !important;
  min-width: 30px !important;
  float: right;
}
.comparison-clear button div.md-ripple {
  margin: 0px !important;
  width: 30px;
}
.md-dialog-container {
  height: 70px;
}
.closeDialogComparison{
  color: red !important;
  background: #ffd3d3;
  width: 32px;
  height: 30px;
  font-size: 18px;
  border: none;
  margin: 5px;
  cursor: pointer;
  position: absolute;
  right: 0px;
}
.closeDialogComparison:hover {
  color: white !important;
  background: red;
}

.md-manual {
  min-width: 88px !important;
  height: 30px !important;
  margin: 0 !important;
  width: 50px;
  position: absolute !important;
  right: 0;
  bottom: 0;
  color: #337ab7;
  border: none;
  cursor: pointer;
  background: #e6f2fd;
}
.md-manual:hover {
  background:  #337ab7;
  color: white;
}


</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DialogComparisons.vue